<template>
  <div ref="chart" class="tabs" v-show="position.show">
    <div :style="{ width: `${position.w}px`, height: `${position.y}px`, paddingTop: '5px' }">
      <div
        :style="{
          height: `${option.style.height}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: `${option.position}`
        }"
      >
        <div
          :style="{
            lineHeight: `${option.style.height}px`,
            paddingLeft: `${option.style.paddingLeft}px`,
            display: 'flex',
            alignItems: 'center',
            color: `${option.style.pickerColor}`,
            fontSize: `${option.style.pickerSize}px`
          }"
        >
          {{ dateTime }}
          <span :style="{ margin: `0 ${option.style.marginRight}px` }">{{ weekTime }}</span>
          {{ currentTime }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 导航配置组件
  name: 'TimeNow',
  components: {},
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    position: {
      type: Object,
      default: () => {}
    }
    // viewType: {
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {
      dateTime: '',
      weekTime: '',
      currentTime: '',
      timer: null
    }
  },
  filters: {},
  computed: {
    fontStyle() {
      const fontstyle = {
        'font-size': `${this.option.fontSize}px`, // 字体大小
        color: this.option.color // 字体颜色
        // 'background-color': this.option.backGroundColorProgress // 进度条背景颜色
      }
      return fontstyle
    },
    // 背景颜色
    backGroundColorStyle() {
      const fontstyle = {
        'background-color': this.option.backgroundColor, // 背景颜色
        'text-align': this.option.textAlign
      }
      return fontstyle
    },
    // 图例颜色
    progressColor() {
      const fontstyle = {
        'background-color': this.option.progressColor
      }
      return fontstyle
    }
  },
  mounted() {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const day = now.getDate()
      const week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][now.getDay()]
      const hour = now.getHours()
      const minute = now.getMinutes()
      const second = now.getSeconds()
      this.dateTime = `${year}/${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}`
      this.weekTime = `${week}`
      this.currentTime = `${hour.toString().padStart(2, '0')}:${minute
        .toString()
        .padStart(2, '0')}:${second.toString().padStart(2, '0')}`
    }
  }
}
</script>

<style scoped lang="less">
.tabs {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.tab-header {
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
}
::v-deep .ant-input {
  background: var(--my-background);
  color: var(--my-color);
  font-size: var(--my-size);
  border: none;
  width: 100%;
}
// .picker {
//   color: var(--my-color) !important;
//   ::v-deep .ant-input {
//     color: var(--my-color) !important;
//   }
//   /* 注意：Less 本身不支持 CSS 变量，但你可以使用 CSS 片段或混合（mixin）来间接使用 */
// }
</style>
